// library imports
import * as React from "react";
import { Grid, Link, Stack } from "@mui/material";
import { AuthenticationContext } from "../Context";
import { useHistory } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useFlash } from "../FlashContext";

interface Props {}

const DiabetesReportIndex: React.FC<Props> = (props: any) => {
  const { currentUser, ..._ } = React.useContext(AuthenticationContext);
  const history = useHistory();
  const { useToast } = useFlash();

  return (
    <div className="patient-index-container">
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        className="container"
      >
        <Grid item xs={12} md={12}>
          <div className="userAdminInformation">
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="stretch"
              className="adminHeader"
            >
              <Grid item xs={12} md={6}>
                <Stack direction="row" columnGap="12px">
                  <Link
                    style={{
                      textDecoration: "none",
                      display: "flex",
                      alignItems: "center",
                    }}
                    href={`/reports`}
                  >
                    <ArrowBackIosNewIcon
                      style={{
                        borderRadius: "3px",
                        padding: "8px",
                        color: "black",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        fontSize: "14px",
                      }}
                    />
                  </Link>
                  <h3>Diabetes Management Program</h3>
                </Stack>
              </Grid>
            </Grid>
          </div>
        </Grid>
        <Grid item xs={12}>
          <div className="divider"></div>
        </Grid>
        <Grid item xs={12} className="admin-report">
          <div className="admin-report--container">
            <Grid
              container
              justifyContent="start"
              style={{ columnGap: "35px" }}
            >
              <Grid
                item
                xs={3}
                className="report-card"
                onClick={() => history.push("a1c-report")}
              >
                <div className="report-card__header"> A1C Labs Report </div>
                <div className="report-card__body">
                  Track and analyze patients’ Hemoglobin A1C levels over time to
                  monitor program progress and patient information.
                </div>
              </Grid>
              <Grid
                item
                xs={3}
                className="report-card"
                onClick={() => history.push("/blood-pressure-report")}
              >
                <div className="report-card__header">Blood Pressure Report</div>
                <div className="report-card__body">
                  Track and analyze patients’ blood pressure levels over time to
                  monitor program progress and patient information.
                </div>
              </Grid>
              <Grid
                item
                xs={3}
                className="report-card"
                onClick={() => history.push("/encounter-invoices-report")}
              >
                <div className="report-card__header">
                  Encounter Invoices Report
                </div>
                <div className="report-card__body">
                  Review detailed billing records for all encounters tied to the
                  NDPERS Diabetes Program, ensuring accurate invoicing and
                  financial tracking.
                </div>
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>
            <Grid
              container
              justifyContent="start"
              style={{ marginTop: 30, columnGap: "35px" }}
            >
              <Grid
                item
                xs={3}
                className="report-card"
                onClick={() => {
                  // showToast({
                  //   text: "Coming soon",
                  //   type: "success",
                  // })
                  history.push("/patient-satisfaction-report")
                }}
              >
                <div className="report-card__header">
                  Patient Satisfaction Report
                </div>
                <div className="report-card__body">
                  Evaluate patient feedback and satisfaction scores to ensure
                  the program meets patient needs.
                </div>
              </Grid>
              <Grid
                item
                xs={3}
                className="report-card"
                onClick={() => history.push("/medication-problems-report")}
              >
                <div className="report-card__header">
                  {" "}
                  Medication Related Problems Report{" "}
                </div>
                <div className="report-card__body">
                  Identify and address all medication issues, such as adherence,
                  side effects, or drug interactions, for patients in the
                  program.
                </div>
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default DiabetesReportIndex;
